import PropTypes from 'prop-types';
import React, { Component } from 'react';
import stringUtils from "../../../utils/string";
import InputField from './InputField';

class OpportunityField extends Component {
    _renderValue () {
        const { opportunity } = this.props.entry;
        return `${opportunity.opportunityId}: ${opportunity.opportunityName}`;
    }

    _getPlaceholder () {
        if (this.props.entry.account.accountId) {
            if (this.props.opportunitiesList.length == 0) {
                return "No Opportunities for this Account";
            }
            return "Select opportunity";
        }
        return "Select account first";
    }

    _hasError () {
        if (this.props.error) {
            return true;
        }

        return this.props.entry.accountId
            && this.props.fieldPermission === 'required'
            && this.props.opportunitiesList.length === 0;
    }

    _getLabel() {
        let label = "Opportunity"
        if (this.props.entry.opportunity && this.props.entry.opportunity.opportunityUsdAmount) {
            label = `${label} (${stringUtils.formatAmount(this.props.entry.opportunity.opportunityUsdAmount)} USD)`
        }
        return label
    }

    render () {
        const { entry } = this.props;
        return (
            <InputField
                hasError={this._hasError()}
                disabled={this.props.opportunitiesList.length === 0}
                required={this.props.fieldPermission === 'required'}
                hidden={this.props.fieldPermission === 'hidden'}
                title={this._getLabel()}
                type="button"
                placeholder={this._getPlaceholder()}
                value={(entry.opportunity) ? entry.opportunity.opportunityId : null}
                colClass={this.props.colClass}
                onClick={() => this.props.onClick()}
                onClear={() => this.props.onClear()}
                onRenderValue={() => this._renderValue()}
            />
        );
    }
}


OpportunityField.propTypes = {
    colClass: PropTypes.string.isRequired,
    entry: PropTypes.object.isRequired,
    fieldPermission: PropTypes.string.isRequired,
    hasError: PropTypes.bool.isRequired,
    onSelectOpportunity: PropTypes.func.isRequired,
    opportunitiesList: PropTypes.array.isRequired,
};


export default OpportunityField;



// WEBPACK FOOTER //
// ./app/components/TimeInput/InputTypes/OpportunityField.jsx